export const styles = {
  sliderContainer: {
    "& .MuiSlider-root": {
      height: "4px",
      maxWidth: "220px",
    },
  },
};
